// © Microsoft Corporation. All rights reserved.

/**
 * Used to mock the LRU cache in test environments.
 */
export class MockLRUCache {

    /** cache */
    private cacheMap: any = {};

    /** Check if cache key exists */
    public async has(key): Promise<boolean> {
        return !!this.cacheMap[key];
    }
    /** Get cached value by key */
    public async get(key): Promise<any> {
        return this.cacheMap[key];
    }
    /** Set cached value by key */
    public async set(key, value, maxAge): Promise<void> {
        this.cacheMap[key] = value;
    }
    /** Delete cached key-value pair */
    public async del(key): Promise<void> {
        delete this.cacheMap[key];
    }
    /** Get count of total items cached */
    public async itemCount(): Promise<number> {
        return Object.keys(this.cacheMap).length;
    }
    /** Reset entire cache */
    public async reset(): Promise<void> {
        this.cacheMap = {};
    }
};